export class RegisterApplication {
  firmName: string;
  firmId: string;
  applicationName: string;
  successUrl: string;
  failureUrl: string;
  cyberScoreThreshold: number;
  bypassAuthentication: boolean;
  appletVerificationByPass: boolean;
  appletVerificationByPassGroups: string;
  gracePeriodApplyToAllUsers: boolean;
  appletcheckByPassIpaddress: boolean;
  appletCheckByPassIpaddressList: string;
  maxFailedRetriesAttempts: number;
  retriesFailedPeriod: number;
  enableRemediation: boolean;
  skipAppletCheckAfterInstalling: boolean;
  thirdPartyServicesActivated: string;
  isHelpEnabled: boolean;
  maxHelpButtonAttempt: number;
  maxHelpButtonAttemptsAllowed: number;
}
